import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormControl from '@material-ui/core/FormControl';
import { useGetUser } from '../../../hooks/useGetUser';
import {
    Select,
    MenuItem,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
} from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment/locale/pt-br';
import FormData from 'form-data';
import styles from './styles.module.scss';
import ButtonsImagesCampain from '../../../components/ButtonsImagesCampain';
import { postConteudo, getConteudoWithId, putConteudo } from '../../../services/api-auto';

import { useDispatch } from 'react-redux';
import {
    showMsgW as showMsgWAction,
    showMsgE as showMsgEAction,
    showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import { b64toBlob } from '../../../services/utils';

import ModalLoading from '../../../components/ModalLoading';
import ButtonsAnexo from '../../../components/ButtonsAnexo';
 

const optionDesktop = {
    width: '1200',
    height: '600',
    widthMM: '317.5',
    heightMM: '158.75'
};

const optionMobile = {
    width: '400',
    height: '400',
    widthMM: '132.29',
    heightMM: '132.29'
};
 

const Detalhes = () => {
    const dispatch = useDispatch();
    const showMsgW = (msg) => dispatch(showMsgWAction(msg));
    const showMsgE = (msg) => dispatch(showMsgEAction(msg));
    const showMsgS = (msg) => dispatch(showMsgSAction(msg));

    const history = useHistory();
    const [nomeArquivo, setNomeArquivo] = useState('');
    const [data, setData] = useState({
        id: '',
        periodoIndeterminado: true,
        dataTermino: moment(),
        status: 1,
        titulo: '',
        textoDestaque: '',
        ordem: 0,
        url: '',
        descricao: '',
        imagemClassificacao: 0,
        imagemDestaque: [{ image: null, blob: null }, { image: null, blob: null }],
        imagemConteudo: [{ image: null, blob: null }, { image: null, blob: null }],
        urlAnexo: null
    });

    const [indicarErros, setIndicarErros] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const optionImagemDestaque = [optionDesktop, optionMobile];
    const optionImagemConteudo = [optionDesktop, optionMobile];
    const optionAnexo = [optionDesktop, optionMobile];

    const validarForm = () => {
        let valid = true;
        let msg = '';

        if (!data.titulo) {
            msg = 'Campo Título obrigatório\n';
            valid = false;
            showMsgW(msg);
            return valid;
        }
        if (data.ordem <= 0) {
            msg = 'A Ordem não pode ser zero e nem negativo\n';
            valid = false;
            showMsgW(msg);
            return valid;
        }
        // if(!data.url){
        //     msg = "Campo Url é obrigatório\n";
        //     valid = false;
        //     showMsgW(msg)
        // }
        if (!data.textoDestaque) {
            msg = 'Campo Texto de destaque é obrigatório\n';
            valid = false;
            showMsgW(msg);
            return valid;
        }
        if (!data.descricao) {
            msg = 'Campo Texto de conteúdo é obrigatório\n';
            valid = false;
            showMsgW(msg);
            return valid;
        }
        if (!data.dataTermino && !data.periodoIndeterminado) {
            msg = 'Campo Ativo até é obrigatório\n';
            valid = false;
            showMsgW(msg);
            return valid;
        }

        if (data.id === '') {
            if (!data.imagemDestaque[0].file || !data.imagemDestaque[1].file || !data.imagemConteudo[0].file || !data.imagemConteudo[1].file) {
                msg = 'Necessário imagens para Desktop e Mobile\n';
                valid = false;
                showMsgW(msg);
                return valid;
            }
        }

        return valid;
    };

    const getConteudoIfEdit = async (id) => {
        if (id) {
            setModalLoading(true);
            try {
                const info = await getConteudoWithId(id);

                let imagemDestaque = [];
                imagemDestaque.push({
                    image: null,
                    blob: b64toBlob(
                        info.data.imagemDestaqueDesktop.fileContents,
                        info.data.imagemDestaqueDesktop.contentType
                    )
                });

                imagemDestaque.push({
                    image: null,
                    blob: b64toBlob(
                        info.data.imagemDestaqueMobile.fileContents,
                        info.data.imagemDestaqueMobile.contentType
                    )
                });

                let imagemConteudo = [];
                imagemConteudo.push({
                    image: null,
                    blob: info.data.imagemConteudoDesktop ?
                        b64toBlob(
                            info.data.imagemConteudoDesktop.fileContents,
                            info.data.imagemConteudoDesktop.contentType
                        ) : null
                });

                imagemConteudo.push({
                    image: null,
                    blob: info.data.imagemConteudoMobile ?
                        b64toBlob(
                            info.data.imagemConteudoMobile.fileContents,
                            info.data.imagemConteudoMobile.contentType
                        ) : null
                });
  
                setData({
                    ...data,
                    id: info.data.id,
                    periodoIndeterminado: info.data.periodoIndeterminado,
                    dataTermino: moment(info.data.dataTermino),
                    status: info.data.status,
                    titulo: info.data.titulo,
                    ordem: info.data.ordem,
                    url: info.data.url,
                    textoDestaque: info.data.textoDestaque,
                    descricao: info.data.descricao,
                    imagemDestaque: imagemDestaque,
                    imagemConteudo: imagemConteudo, 
                    urlAnexo: info.data.urlAnexo
                });
            } catch (e) {
                showMsgW('Não foi possível carregar os dados');
            }
            setModalLoading(false);
        }
    };

    const createSenderForm = () => {
        let formdata = new FormData();

        if (data.id !== '') {
            formdata.append('id', data.id);
        }
        formdata.append('titulo', data.titulo);
        formdata.append('dataTermino', data.dataTermino ? data.dataTermino.format('DD/MM/YYYY') : new moment(new Date()).format('DD/MM/YYYY'));
        formdata.append('Status', data.status);
        formdata.append('periodoIndeterminado', data.periodoIndeterminado);
        formdata.append('ordem', data.ordem);
        formdata.append('url', data.url);
        formdata.append('textoDestaque', data.textoDestaque);
        formdata.append('descricao', data.descricao);
        formdata.append('imagemDestaqueDesktop', data.imagemDestaque[0].file ?? null);
        formdata.append('imagemDestaqueMobile', data.imagemDestaque[1].file ?? null);
        formdata.append('imagemConteudoDesktop', data.imagemConteudo[0].file ?? null);
        formdata.append('imagemConteudoMobile', data.imagemConteudo[1].file ?? null);
        formdata.append('urlAnexo', data.urlAnexo);

        return formdata;
    };

    const enviar = async () => {
        setIndicarErros(false);

        if (validarForm()) {
            let formdata = createSenderForm();
            setModalLoading(true);
            try {
                const info =
                    data.id === '' || data.id === undefined || data.id === null
                        ? await postConteudo(formdata)
                        : await putConteudo(formdata);

                showMsgS('Dados salvos com sucesso!');
                setTimeout(() => {
                    history.push('/conteudo');
                }, 2000);
            } catch (e) {
                e.response
                    ? showMsgE(e.response.data)
                    : showMsgE('Ocorreu um erro ao salvar os dados.');
            } finally {
                setModalLoading(false);
            }
        }
    };

    const handleImagemDestaque = (file, imagemClassificacao) => {
        data.imagemDestaque[imagemClassificacao].file = file;
        data.imagemDestaque[imagemClassificacao].blob = file;
        //para chamar novamente o carregamento
        setData({
            ...data,
            imagemClassificacao: imagemClassificacao
        });
    };

    const handleImagemConteudo = (file, imagemClassificacao) => {
        data.imagemConteudo[imagemClassificacao].file = file;
        data.imagemConteudo[imagemClassificacao].blob = file;
        //para chamar novamente o carregamento
        setData({
            ...data,
            imagemClassificacao: imagemClassificacao
        });
    };
    useEffect(() => {
        getConteudoIfEdit();
        const conteudo = new URLSearchParams(history.location.search).get(
            'conteudo'
        );
        getConteudoIfEdit(conteudo);
    }, []);

    const user = useGetUser();

    return (
        <>
            {(user.perfilAcesso === 'Master') && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            Cadastro de Conteúdo
                            <button
                                className={styles.backButton}
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                        </div>
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div
                                    className={styles.card}
                                    style={{ padding: '16px 16px 6px 16px' }}
                                >
                                    <FormControl className={styles.twoThird}>
                                        <TextField
                                            type="text"
                                            size="small"
                                            onChange={(e) => {
                                                setData({ ...data, titulo: e.target.value });
                                            }}
                                            label="Título"
                                            value={data.titulo}
                                            variant="filled"
                                            error={indicarErros && !data.titulo ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.third}>
                                        <InputLabel id="select-status-label" className={styles.label}>
                                            Status
                                        </InputLabel>
                                        <Select
                                            labelId="select-status-label"
                                            label="Status"
                                            onChange={(e) => {
                                                setData({ ...data, status: e.target.value });
                                            }}
                                            value={data.status}
                                            variant="filled"
                                            className="customFilledInput"
                                        >
                                            <MenuItem value={1}>Ativo</MenuItem>
                                            <MenuItem value={0}>Inativo</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormControl className={styles.third}>
                                        <TextField
                                            type="number"
                                            size="small"
                                            onChange={(e) => {
                                                setData({ ...data, ordem: e.target.value });
                                            }}
                                            label="Ordem"
                                            value={data.ordem}
                                            variant="filled"
                                            error={indicarErros && !data.ordem ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.twoThird}>
                                        <TextField
                                            type="text"
                                            size="small"
                                            onChange={(e) => {
                                                setData({ ...data, url: e.target.value });
                                            }}
                                            label="URL"
                                            value={data.url}
                                            variant="filled"
                                            error={indicarErros && !data.url ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <FormControl className={styles.full}>
                                        <TextField
                                            type="text"
                                            size="small"
                                            onChange={(e) => {
                                                setData({ ...data, textoDestaque: e.target.value });
                                            }}
                                            label="Texto de destaque"
                                            value={data.textoDestaque}
                                            variant="filled"
                                            error={indicarErros && !data.textoDestaque ? true : false}
                                            className="customFilledInput"
                                        />
                                    </FormControl>
                                    <div className={styles.topSpacing}>
                                        <div className={styles.subtitleConfiguracao}>
                                            Período de Atividade
                                        </div>
                                        <div className={styles.atividade}>
                                            <FormControl component="fieldset">
                                                <FormControlLabel
                                                    value="Indeterminado"
                                                    control={
                                                        <Checkbox
                                                            style={{ color: '#5CCBE1' }}
                                                            checked={data.periodoIndeterminado}
                                                            onChange={(e) => {
                                                                setData({
                                                                    ...data,
                                                                    periodoIndeterminado: true,
                                                                });
                                                            }}
                                                        />
                                                    }
                                                    label="Indeterminado"
                                                    className={styles.radioOptions}
                                                />
                                            </FormControl>
                                            <FormControl component="fieldset">
                                                <FormControlLabel
                                                    value="Determinado"
                                                    control={
                                                        <Checkbox
                                                            style={{ color: '#5CCBE1' }}
                                                            checked={!data.periodoIndeterminado}
                                                            onChange={(e) => {
                                                                setData({
                                                                    ...data,
                                                                    periodoIndeterminado: false,
                                                                });
                                                            }}
                                                        />
                                                    }
                                                    label="Determinado"
                                                    className={styles.radioOptions}
                                                />
                                            </FormControl>
                                            {!data.periodoIndeterminado ? (
                                                <FormControl className={styles.third}>
                                                    <MuiPickersUtilsProvider
                                                        locale="pt-br"
                                                        libInstance={moment}
                                                        utils={MomentUtils}
                                                    >
                                                        <KeyboardDatePicker
                                                            autoOk
                                                            variant="inline"
                                                            inputVariant="outlined"
                                                            label="Ativo até"
                                                            format="DD/MM/yyyy"
                                                            value={data.dataTermino}
                                                            InputAdornmentProps={{ position: 'start' }}
                                                            onChange={(novaData) => {
                                                                setData({ ...data, dataTermino: novaData });
                                                            }}
                                                            className="customFilledInput"
                                                            error={
                                                                indicarErros && !data.dataTermino ? true : false
                                                            }
                                                            invalidDateMessage="Data em formato inválido."
                                                            maxDateMessage="Data não deve ser maior que a data máxima."
                                                            minDateMessage="Data não deve ser menor que a data mínima."
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </FormControl>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className={styles.topSpacing}>
                                        <div className={styles.subtitleConfiguracao}>Conteúdo</div>
                                        <div className={styles.atividade}>
                                            <FormControl className={styles.full}>
                                                <TextareaAutosize
                                                    type="text"
                                                    size="small"
                                                    onChange={(e) => {
                                                        setData({ ...data, descricao: e.target.value });
                                                    }}
                                                    label="Descrição"
                                                    value={data.descricao}
                                                    variant="filled"
                                                    error={indicarErros && !data.descricao ? 'true' : 'false'}
                                                    className="customFilledInput"
                                                    minRows={4}
                                                />
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>Imagens</div>
                                    <div className={styles.divImageList}>
                                        <FormControl className={styles.halfRadio}>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                defaultValue={0}
                                                value={data.imagemClassificacao}
                                                style={{ flexWrap: 'nowrap' }}
                                                onChange={(e) => {
                                                    setData({
                                                        ...data,
                                                        imagemClassificacao: parseInt(e.target.value),
                                                    });
                                                }}
                                            >
                                                <FormControlLabel
                                                    value={0}
                                                    control={<Radio style={{ color: '#5CCBE1' }} />}
                                                    label="Desktop"
                                                />
                                                <FormControlLabel
                                                    value={1}
                                                    control={<Radio style={{ color: '#5CCBE1' }} />}
                                                    label="Mobile"
                                                />
                                            </RadioGroup>
                                        </FormControl>

                                        <ButtonsImagesCampain
                                            texto="Banner que será exibido na área de destaque."
                                            width={optionImagemDestaque[data.imagemClassificacao].width}
                                            height={optionImagemDestaque[data.imagemClassificacao].height}
                                            widthMM={optionImagemDestaque[data.imagemClassificacao].widthMM}
                                            heightMM={optionImagemDestaque[data.imagemClassificacao].heightMM}
                                            image={data.imagemDestaque[data.imagemClassificacao].image}
                                            blob={data.imagemDestaque[data.imagemClassificacao].blob}
                                            changeImage={(file) => {
                                                handleImagemDestaque(file, data.imagemClassificacao);
                                            }}
                                            error={
                                                indicarErros &&
                                                    !data.imagemDestaque[0].file &&
                                                    !data.imagemDestaque[1].file
                                                    ? true
                                                    : false
                                            }
                                        />
                                        <ButtonsImagesCampain
                                            texto="Banner descritivo exibido no detalhe do conteúdo."
                                            width={optionImagemConteudo[data.imagemClassificacao].width}
                                            height={optionImagemConteudo[data.imagemClassificacao].height}
                                            widthMM={optionImagemConteudo[data.imagemClassificacao].widthMM}
                                            heightMM={optionImagemConteudo[data.imagemClassificacao].heightMM}
                                            image={data.imagemConteudo[data.imagemClassificacao].image}
                                            blob={data.imagemConteudo[data.imagemClassificacao].blob}
                                            changeImage={(file) => {
                                                handleImagemConteudo(file, data.imagemClassificacao);
                                            }}
                                            error={
                                                indicarErros &&
                                                    !data.imagemConteudo[0].file &&
                                                    !data.imagemConteudo[1].file
                                                    ? true
                                                    : false
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <div className={styles.subtitle}>Anexo</div>
                                    <div className={styles.divImageList}>
                              
                                            <ButtonsAnexo
                                                changeImage={(file, nome) => {
                                                    setData({ ...data, urlAnexo: file });
                                                    setNomeArquivo(nome);
                                                }}
                                                texto="Incluir anexo"
                                                // formatos={['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']}
                                                tamanho="5 MB"
                                                nomeArquivo={nomeArquivo}
                                                modalLoading={setModalLoading}
                                                />
                                                {data.urlAnexo && <a href={data.urlAnexo} className={styles.verAnexo} target="_blank">
                                                {' '}
                                                Ver anexo
                                                </a>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.blueBackground}>
                            <div className={styles.content}>
                                <div className={styles.card}>
                                    <button className={styles.salvar} onClick={enviar}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ModalLoading open={modalLoading} size="lg" />
                </>
            )}
        </>
    );
};

export default Detalhes;